// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01b66{margin-left:var(--ds-space-050,4px)}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._s7n4nkob{vertical-align:middle}", ""]);
// Exports
module.exports = exports;
